import * as React from "react";
import {FC, useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {Grid, Tab, Tabs} from "@mui/material";
import {BrickText} from "../../BrickMailType";
import {FormInputHtml} from "../../../../shop/wholesale/form/FormInputHtml";
import {FormInputText} from "../../../../shop/wholesale/form/FormInputText";
import {FormInputColor} from "../../../../shop/wholesale/form/FormInputColor";
import {FormInputCheckbox} from "../../../../shop/wholesale/form/FormInputCheckbox";

export const BrickTextEditor: FC<{ brick: BrickText, onChange: (brick: BrickText) => void }> = ({brick, onChange}) => {
   const [tab, setTab] = useState<'text' | 'options'>('text')
   const formContext = useFormContext<BrickText>();
   const {reset, control} = formContext;

   useEffect(() => {
      reset(brick)
   }, [brick, reset])

   return (
      <div>
         <Tabs value={tab}>
            <Tab value={'text'} label={"Text"} onClick={() => setTab("text")}/>
            <Tab value={'options'} label={"Options"} onClick={() => setTab("options")}/>
         </Tabs>
         {tab === 'text' && <FormInputHtml height={'250px'} name={"value"} label={"Text"}/>}
         {tab === 'options' && <Grid container spacing={"10px"}>
            <Grid item xs={6}>
               <FormInputText name={"fontSize"} control={control} label={"Font size"}/>
            </Grid>
            <Grid item xs={6}>
               <FormInputText name={"fontFamily"} control={control} label={"Font family"}/>
            </Grid>
            <Grid item xs={6}>
               <FormInputColor name={"color"} control={control} label={"Text color"} defaultColor={"#000000"}/>
            </Grid>
            <Grid item xs={6}>
               <FormInputColor name={"backgroundColor"} control={control} label={"Background color"}
                               defaultColor={"#ffffff"}/>
            </Grid>
            <Grid item xs={6}>
               <FormInputText name={"margin"} control={control} label={"Margin"}/>
            </Grid>
            <Grid item xs={6}>
               <FormInputText name={"align"} control={control} label={"Align (left, center, right)"}/>
            </Grid>
            <Grid item xs={6}>
               <FormInputCheckbox name={"bold"} control={control} label={"Bold"}/>
               <FormInputCheckbox name={"disablePadding"} control={control} label={"Disable padding"}/>
            </Grid>
            <Grid item xs={12}>
               <FormInputText name={"activation"} control={control} label={"Activation expression"}/>
            </Grid>
         </Grid>}
      </div>
   );
}
